import React, { Component } from "react";
import config from "react-global-configuration";
import jwt_decode from "jwt-decode";
import { Link, Redirect } from "react-router-dom";
import $ from "jquery";
import "../css/ipos-navbar.css";
import "../css/TotalEMI.css";
import DownArrow from "../../assets/img/welcomepage/down-arrow.png";
import BellIcon from "../../assets/img/welcomepage/TopbarIcons/bell.png";
import HomeIcon from "../../assets/img/welcomepage/TopbarIcons/home-icon.png";

const tog = "collapse";
const tar = "navbar-collapse-1";
class Navbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      emiMenus: [],
      navborder: { borderBottom: "1px rgba(23, 21, 21, 0.88);" },
    };
  }
  componentDidMount() {}

  activeclass = () => {
    //    alert('active');
    $("#iposnav").removeClass("active");
    $("#iposnav").addClass("active");
  };
  toggle = () => {
    // e.preventDefault();
    $("#iposnav").toggleClass("collapse");
  };
  homepage = () => {
    return <Redirect to="/admin/welcomepage" />;
  };
  render() {
    return (
      <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0">
        <div className="container-fluid">
          <div className="row">
            <div className="rectangle">
              <p className="all-terminals" style={{ lineHeight: "30px" }}>
                <Link to="/admin/welcomepage">
                  <img
                    src={HomeIcon}
                    style={{
                      float: "left",
                      height: "30px",
                      paddingLeft: "10px",
                    }}
                  />
                </Link>
                <span
                  style={{
                    fontSize: "130%",
                    color: "darkblue",
                    fontWeight: "600",
                  }}
                >
                  Total EMI
                </span>
                <img
                  src={BellIcon}
                  style={{
                    float: "right",
                    paddingRight: "5px",
                    height: "30px",
                  }}
                />
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Navbar;
